import type { ReactNode } from 'react';

export const symbol_emoticon: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M249.9-280q-20.9 0-35.4-14.5T200-329.9q0-20.1 14.5-35.1t35.4-15q20.1 0 35.1 15t15 35.1q0 20.9-15 35.4T249.9-280Zm0-300q-20.9 0-35.4-14.5T200-629.9q0-20.1 14.5-35.1t35.4-15q20.1 0 35.1 15t15 35.1q0 20.9-15 35.4T249.9-580ZM430-450q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H430Zm270-30q0-57.58-16.54-110.9Q666.93-644.21 635-689q-8-11-7.5-24t10.5-21q10-8 22-6.5t20 12.5q37.89 53.21 58.95 115.97Q760-549.28 760-480q0 57.42-14.5 109.71Q731-318 705-272q-5.8 11.09-17.4 14.04Q676-255 665-262q-11-7-13-19.5t4-23.5q20.84-40.22 32.42-83.7Q700-432.17 700-480Z"
		/>
	</svg>
);
